import { render, staticRenderFns } from "./AttendanceRecordsResponsesSummaryCard.vue?vue&type=template&id=248e98d1"
import script from "./AttendanceRecordsResponsesSummaryCard.vue?vue&type=script&lang=js"
export * from "./AttendanceRecordsResponsesSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports